var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-hide"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('optionHide.hide'))+" "+_vm._s(_vm.label))]),_c('v-switch',{attrs:{"inset":"","hide-details":"","ripple":false},on:{"change":_vm.setHideElement},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }